import { SortParams } from '../../../typings/grid';

export const SORT_INTERNAL_MARKETERS = 'SORT_INTERNAL_MARKETERS';
export type SORT_INTERNAL_MARKETERS = typeof SORT_INTERNAL_MARKETERS;

export interface SortInternalMarketers {
    type: SORT_INTERNAL_MARKETERS;
    sortParams: SortParams;
}

export function sortInternalMarketersAction(sortParams: SortParams): SortInternalMarketers {
    return {
        type: SORT_INTERNAL_MARKETERS,
        sortParams
    };
}
